export default __webpack_public_path__ + "static/CentraNo2-LightItalic-1ee138262ef9521437c4689338ae41a2.woff";